import React, { useState, useRef, useEffect } from "react";
import "./servicos.css";

/* ============================= */
/* SERVIÇOS / ORIENTAÇÃO ACADÊMICA */
/* ============================= */
const servicosData = [
  {
    id: 1,
    titulo: "Revisão Técnica de TCC",
    imagem: "/Images/revisao-tcc.jpg",
    resumo:
      "Análise técnica do conteúdo do TCC, avaliando coerência, metodologia e aplicação correta dos conceitos de Engenharia Civil.",
    detalhes: [
      "Avaliação da estrutura do trabalho",
      "Análise técnica dos capítulos",
      "Verificação de coerência metodológica",
      "Adequação ao tema proposto",
      "Orientações claras para correção",
    ],
  },
  {
    id: 2,
    titulo: "Revisão e Formatação ABNT",
    imagem: "/Images/revisao-abnt.jpg",
    resumo:
      "Correção e padronização completa conforme normas ABNT aplicáveis a trabalhos acadêmicos.",
    detalhes: [
      "Citações e referências",
      "Margens, espaçamentos e fontes",
      "Sumário e numeração correta",
      "Padronização de tabelas e figuras",
      "Conferência final do documento",
    ],
  },
  {
    id: 3,
    titulo: "Apoio em Cálculos Estruturais",
    imagem: "/Images/calculos-estruturais.jpg",
    resumo:
      "Auxílio técnico na compreensão e verificação de cálculos estruturais aplicados ao TCC.",
    detalhes: [
      "Dimensionamento de elementos estruturais",
      "Conferência de cálculos",
      "Interpretação de resultados",
      "Apoio em memorial de cálculo",
      "Orientação conforme normas técnicas",
    ],
  },
  {
    id: 4,
    titulo: "Orientação Acadêmica Individual",
    imagem: "/Images/orientacao-academica.jpg",
    resumo:
      "Atendimento individual para esclarecimento de dúvidas técnicas e direcionamento acadêmico.",
    detalhes: [
      "Orientação por chamada online",
      "Esclarecimento de dúvidas técnicas",
      "Apoio em metodologia científica",
      "Direcionamento para ajustes no trabalho",
    ],
  },
  {
    id: 5,
    titulo: "Análise de Metodologia Científica",
    imagem: "/Images/metodologia-cientifica.jpg",
    resumo:
      "Avaliação da metodologia adotada no trabalho acadêmico, garantindo clareza e rigor científico.",
    detalhes: [
      "Definição de objetivos e hipóteses",
      "Adequação do método de pesquisa",
      "Coerência entre metodologia e resultados",
      "Orientações para correção",
    ],
  },
  {
    id: 6,
    titulo: "Preparação para Banca Avaliadora",
    imagem: "/Images/banca-avaliadora.jpg",
    resumo:
      "Apoio técnico para revisão final e preparação do aluno para apresentação do TCC.",
    detalhes: [
      "Revisão técnica final do trabalho",
      "Orientações para apresentação oral",
      "Ajustes conforme critérios da banca",
      "Maior segurança na defesa",
    ],
  },
];

function Servicos() {
  const [aberto, setAberto] = useState(null);
  const trackRef = useRef(null);

  const isDragging = useRef(false);
  const pauseAutoplay = useRef(false);

  const startX = useRef(0);
  const scrollLeft = useRef(0);

  /* AUTOPLAY SUAVE COM PAUSA */
  useEffect(() => {
    const track = trackRef.current;

    const autoplay = () => {
      if (!isDragging.current && !pauseAutoplay.current) {
        track.scrollLeft += 0.4;
        if (track.scrollLeft >= track.scrollWidth / 2) {
          track.scrollLeft = 0;
        }
      }
      requestAnimationFrame(autoplay);
    };

    requestAnimationFrame(autoplay);
  }, []);

  /* DRAG */
  const handleMouseDown = (e) => {
    isDragging.current = true;
    pauseAutoplay.current = true;
    startX.current = e.pageX;
    scrollLeft.current = trackRef.current.scrollLeft;
    trackRef.current.classList.add("dragging");
  };

  const handleMouseUp = () => {
    isDragging.current = false;
    trackRef.current.classList.remove("dragging");

    setTimeout(() => {
      pauseAutoplay.current = false;
    }, 3000);
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    const walk = (e.pageX - startX.current) * 1.6;
    trackRef.current.scrollLeft = scrollLeft.current - walk;
  };

  /* SETAS */
  const scrollByCard = (direction) => {
    pauseAutoplay.current = true;

    const cardWidth = 320 + 24;
    trackRef.current.scrollBy({
      left: direction === "right" ? cardWidth : -cardWidth,
      behavior: "smooth",
    });

    setTimeout(() => {
      pauseAutoplay.current = false;
    }, 3000);
  };

  return (
    <section id="servicos" className="servicos-section">
      <div className="container">

        {/* TÍTULO */}
        <div className="titulo-bloco">
          <h2>Orientação e Apoio Acadêmico</h2>

          <div className="imagem-full">
            <img
              src="/Images/timthumb.jpg"
              alt="Apoio acadêmico em Engenharia Civil"
            />
          </div>

          <span className="linha-destaque"></span>

          <p className="servicos-subtitle">
            Serviços especializados de correção, orientação e apoio técnico
            para TCCs e trabalhos acadêmicos em Engenharia Civil.
          </p>
        </div>

        {/* CARROSSEL */}
        <div className="carousel-wrapper">

          <button
            className="carousel-arrow left"
            onClick={() => scrollByCard("left")}
            aria-label="Anterior"
          >
            ‹
          </button>

          <button
            className="carousel-arrow right"
            onClick={() => scrollByCard("right")}
            aria-label="Próximo"
          >
            ›
          </button>

          <div
            className="carousel-track"
            ref={trackRef}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            onMouseMove={handleMouseMove}
          >
            {[...servicosData, ...servicosData].map((item, index) => (
              <article className="ensaio-card" key={index}>
                <img src={item.imagem} alt={item.titulo} />

                <div className="ensaio-content">
                  <h4>{item.titulo}</h4>
                  <p>{item.resumo}</p>

                  <button
                    className="btn-detalhes"
                    onClick={() =>
                      setAberto(aberto === item.id ? null : item.id)
                    }
                  >
                    {aberto === item.id ? "Ocultar detalhes" : "Ver detalhes"}
                  </button>

                  {aberto === item.id && (
                    <div className="ensaio-detalhes">
                      <ul>
                        {item.detalhes.map((linha, i) => (
                          <li key={i}>{linha}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </article>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}

export default Servicos;
